import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmportfoliopoint/cecUnmPortfolioPoint/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmportfoliopoint/cecUnmPortfolioPoint/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmportfoliopoint/cecUnmPortfolioPoint/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmportfoliopoint/cecUnmPortfolioPoint/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmportfoliopoint/cecUnmPortfolioPoint/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmportfoliopoint/cecUnmPortfolioPoint/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmportfoliopoint/cecUnmPortfolioPoint/import',
      method: 'post',
      data: data
    })
  }
}
